// @flow
import { useEffect } from 'react';
import Debug from 'debug';
import type { Model as ModelType } from '../../../server/shared/types';

const debug = Debug('amms:modules:sync:syncData');

type Props = $ReadOnly<{
    label?: string,
    Model: ModelType<*>,
    onLoad?: ($ReadOnlyArray<any>) => void,
    onAdd?: (value: *) => void,
    onChange?: (value: *) => void,
    onDelete?: (value: *) => void
}>;

function SyncData({ label, Model, onLoad, onAdd, onChange, onDelete }: Props) {
    useEffect(() => {
        debug(`Starting syncing of ${label}`);
        const { unsubscribe } = Model.subscribe({ onLoad, onAdd, onChange, onDelete });

        return () => {
            debug(`Stopping syncing of ${label}`);
            unsubscribe();
        };
    }, [label, Model, onLoad, onAdd, onChange, onDelete]);

    return null;
}

export default SyncData;